<div class="system-connection-key-dialog">
  <mat-dialog-content>
    <div class="row">
      <div class="col-12">
        <div class="mat-subtitle-1 header">Enter Secret Key</div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <p>Please enter the secret key to view connection details:</p>
        <mat-form-field>
          <mat-label>Secret Key</mat-label>
          <input matInput type="password" [(ngModel)]="secretKey" (keyup.enter)="onSubmit()">
        </mat-form-field>
        @if (error) {
          <p class="text-danger">{{ error }}</p>
        }
      </div>
    </div>

    <div class="row">
      <div class="col-6">
        <button mat-stroked-button color="primary" mat-dialog-close>Cancel</button>
      </div>
      <div class="col-6 text-right">
        <button mat-flat-button color="primary" class="w-lt-md-100" (click)="onSubmit()" [disabled]="!secretKey">Submit</button>
      </div>
    </div>
  </mat-dialog-content>
</div> 